export default {
    closetPoint(subjPolyPoint, subtrPoly) {
        var minIndexes = [];

        for (var j = 0; j < subtrPoly.length; j++) {
            var minLength = this.Length(subjPolyPoint, subtrPoly[j][0]);
            var minIndex = 0;

            for (var i = 1; i < subtrPoly[j].length; i++) {
                var newLength = this.Length(subjPolyPoint, subtrPoly[j][i])
                if (minLength > newLength) {
                    minLength = newLength;
                    minIndex = i;
                }
            }

            minIndexes.push({arrayIndex: j, elementIndex: minIndex});
        }

        return minIndexes;
    },

    Length: (point1, point2) => {
        var x1 = point1.x,
            x2 = point2.x,
            y1 = point1.y,
            y2 = point2.y;

        return Math.sqrt((x1 -= x2) * x1 + (y1 -= y2) * y1);
    },

    sortPolygonArray: (array, indexes) => {
        var result = [];

        for (var i = 0; i < indexes.length; i++) {
            var newArray = [];
            var originalLength = array[indexes[i].arrayIndex].length;

            while (newArray.length != originalLength) {
                if (indexes[i].elementIndex == originalLength) {
                    indexes[i].elementIndex = 0;
                }

                newArray.push(array[indexes[i].arrayIndex][indexes[i].elementIndex]);
                indexes[i].elementIndex++;
            }

            result.push(newArray);
        }

        return result;
    },

    combinePolygonArrays: (subjPoly, subtrPoly) => {

        var newArray = subjPoly;
        var lastSubjectPoint = subjPoly[subjPoly.length - 1];

        for (var i = 0; i < subtrPoly.length; i++) {
            var firstSubtractedPoint = subtrPoly[i][0];

            newArray = newArray.concat(subtrPoly[i]);
            newArray.push(firstSubtractedPoint);
            newArray.push(lastSubjectPoint);
        }

        return newArray;
    }
}